import { Col as AntCol } from 'antd';
import styled from 'styled-components';

import { Row as AntRow } from '@atom/grid/row/row';
import { Title } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

import Icon from './assets/app.icon.svg?react';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const AppIcon = styled(Icon)`
  flex: 0 0 32px;
`;

export const HeaderTitle = styled(Title).attrs({
  level: 4,
  weight: 400,
})`
  color: ${ColorEnum.Teal100} !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StatRow = styled(AntRow)`
  padding: 16px 8px 24px;
  width: 100%;
  border-bottom: 1px solid ${ColorEnum.Black30};
  margin-bottom: 16px;
`;

export const StatCol = styled(AntCol)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  border-right: 1px solid ${ColorEnum.Black30};
  padding: 0 16px !important;
  gap: 4px;

  &:first-child {
    padding-left: 0 !important;
  }

  &:last-child {
    border-right: none;
    padding-right: 0 !important;
  }
`;

export const ChartWrapper = styled.div`
  padding: 8px 0;
`;

export const SettingsWrapper = styled.div`
  margin-left: auto;
`;

export const SettingsButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;
